<div class="search-bar-container">
  <div class="input-wrapper">
    <input
      #searchInput
      type="text"
      [formControl]="control"
      class="real-input"
      spellcheck="false"
      placeholder=" "
      (focus)="onInputFocus()"
    >
    <label class="input-label">
      {{ "paxForms.destinationAddressAutocomplete.destinationAddressInput" | translate }}
    </label>

    <div class="powered-by">
      <img
        class="google-logo"
        src="../../../../../../assets/images/forms/power-by-google.svg"
        alt="Google Logo"
      >
    </div>
  </div>

  <button class="close-btn" (click)="close.emit()">
    <i class="fa-xmark"></i>
  </button>
</div>